import React from "react";
import { Box, Flex, Image, Link, Text } from "@chakra-ui/react";
import { footerSubLinks, socials } from "../common/constants";

const DSA_FOOTER_LINKS = footerSubLinks.filter(
  (item) => item.name !== "DSA Agreement"
);

const Footer = ({ variant = "default" }) => {
  const today = new Date();
  const isDsa = variant === "dsa";
  const links = isDsa ? DSA_FOOTER_LINKS : footerSubLinks;

  if (isDsa) {
    return (
      <Flex
        justifyContent="center"
        bg="#052214"
        className="full_width"
        color="#fff"
        fontFamily="Poppins"
      >
        <Box
          w={{ base: "100%", md: "1326px" }}
          px={{ base: "20px", md: "48px", lg: "64px" }}
          pt={{ base: "48px", md: "64px" }}
          pb={{ base: "36px", md: "48px" }}
        >
          <Flex
            flexDir={{ base: "column", md: "row" }}
            justifyContent="space-between"
            gap={{ base: "40px", md: "48px" }}
          >
            <Flex flexDir="column" align={{ base: "center", md: "flex-start" }}>
              <Image
                src="/assets/dark-logo.png"
                ml={{ base: "0", md: "-25px" }}
                h="39.3px"
                objectFit="contain"
              />
              <Text
                mt={{ base: "28px", md: "20px" }}
                mb={{ base: "12px", md: "16px" }}
                color="#fff"
                fontSize={{ base: "12px", md: "14px" }}
                lineHeight={{ base: "16.8px", md: "19.6px" }}
              >
                Available on
              </Text>

              <Flex align="center" gap="16px">
                <a
                  href="https://play.google.com/store/apps/details?id=com.fastamoniorg.bizflex"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Flex
                    bg="#0A2E22"
                    borderRadius="8px"
                    gap="8px"
                    align="center"
                    px="16px"
                    py="14px"
                  >
                    <Image
                      src="/assets/android.svg"
                      w="24px"
                      h="24px"
                      objectFit="contain"
                    />
                    <Text color="#fff" fontSize="15px" lineHeight="21px">
                      Android
                    </Text>
                  </Flex>
                </a>

                <a
                  href="https://apps.apple.com/us/app/bizflex-africa/id6754340965"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Flex
                    bg="#0A2E22"
                    borderRadius="8px"
                    gap="8px"
                    align="center"
                    px="16px"
                    py="14px"
                  >
                    <Image
                      src="/assets/apple.svg"
                      w="24px"
                      h="24px"
                      objectFit="contain"
                    />
                    <Text color="#fff" fontSize="15px" lineHeight="21px">
                      iOS
                    </Text>
                  </Flex>
                </a>
              </Flex>

              <Flex
                mt="16px"
                align="center"
                gap="10px"
                justify={{ base: "center", md: "flex-start" }}
              >
                <Image
                  src="/assets/Ndrc.svg"
                  alt="Regulatory badges"
                  h={{ base: "44px", md: "52px" }}
                  w="auto"
                  objectFit="contain"
                />
              </Flex>
            </Flex>

            <Box textAlign={{ base: "center", md: "end" }} maxW={{ md: "520px" }}>
              <Flex
                align="center"
                gap="12px"
                justifyContent={{ base: "center", md: "flex-end" }}
              >
                {socials.map((item, i) => (
                  <Flex
                    key={i}
                    bg="#2463EB"
                    rounded="full"
                    w="32px"
                    h="32px"
                    justifyContent="center"
                    align="center"
                  >
                    <a href={item?.link} target="_blank" rel="noreferrer">
                      <Image
                        src={item?.img}
                        w="16px"
                        h="16px"
                        objectFit="contain"
                      />
                    </a>
                  </Flex>
                ))}
              </Flex>

              <Text
                mt="18px"
                color="#fff"
                fontSize={{ base: "12px", md: "14px" }}
                lineHeight={{ base: "18px", md: "22px" }}
              >
                <Text as="span" fontWeight={700}>
                  Email:
                </Text>{" "}
                support@bizflex.africa
              </Text>
              <Text
                mt="10px"
                color="#fff"
                fontSize={{ base: "12px", md: "14px" }}
                lineHeight={{ base: "18px", md: "22px" }}
              >
                <Text as="span" fontWeight={700}>
                  Phone:
                </Text>{" "}
                02012296204
              </Text>
              <Text
                mt="10px"
                color="#fff"
                fontSize={{ base: "12px", md: "14px" }}
                lineHeight={{ base: "18px", md: "22px" }}
              >
                <Text as="span" fontWeight={700}>
                  Address:
                </Text>{" "}
                4th Floor, Polystar Tower, 128, Remi Olowude Street, Lekki Phase
                1, Lagos
              </Text>

              <Text
                mt="16px"
                color="rgba(255,255,255,0.72)"
                fontSize={{ base: "11px", md: "13px" }}
                lineHeight={{ base: "18px", md: "20px" }}
              >
                BizFlex is a financial technology product offered by FastaMoni
                Technologies Limited. BizFlex is not a bank; all banking
                services are provided by our licensed banking partners.
              </Text>

              <Flex
                mt="18px"
                justifyContent={{ base: "center", md: "flex-end" }}
                align="center"
                gap="8px"
                flexWrap="wrap"
                color="rgba(255,255,255,0.55)"
                fontSize={{ base: "12px", md: "13px" }}
                lineHeight="20px"
              >
                {links.map((item, i) => (
                  <React.Fragment key={item.id}>
                    {i > 0 ? (
                      <Text as="span" color="rgba(255,255,255,0.35)">
                        |
                      </Text>
                    ) : null}
                    <Link href={`/${item.id}`} _hover={{ color: "#fff" }}>
                      {item.name}
                    </Link>
                  </React.Fragment>
                ))}
              </Flex>

              <Text
                mt="10px"
                color="rgba(255,255,255,0.45)"
                fontSize={{ base: "11px", md: "13px" }}
                lineHeight="20px"
              >
                © {today.getFullYear()} Fastamoni. All rights reserved.
              </Text>
            </Box>
          </Flex>
        </Box>
      </Flex>
    );
  }

  return (
    <Flex
      justifyContent="center"
      bg="dark"
      className="full_width"
      color="#fff"
      fontFamily="Poppins"
    >
      <Box
        w={{ base: "100", md: "1326px" }}
        p={{ base: "26px 0", md: "6px 61px 75px 100px" }}
      >
        <Flex
          pt={{ base: "40px", md: "100px" }}
          flexDir={{ base: "column", md: "row" }}
          justifyContent="space-between"
          gap={{ base: "50px", md: "unset" }}
        >
          <Flex flexDir="column" align={{ base: "center", md: "flex-start" }}>
            <Image
              src="/assets/dark-logo.png"
              ml="-25px"
              h="39.3px"
              objectFit="contain"
            />
            <Text
              mt={{ base: "41px", md: "18.7px" }}
              mb={{ base: "11px", md: "20px" }}
              color="#fff"
              fontSize={{ base: "12px", md: "14px" }}
              lineHeight={{ base: "16.8px", md: "19.6px" }}
            >
              Available on
            </Text>

            <Flex align="center" gap="16px">
              <a
                href="https://play.google.com/store/apps/details?id=com.fastamoniorg.bizflex"
                target="_blank"
                rel="noreferrer"
              >
                <Flex
                  bg="#1A1C1F"
                  borderRadius="8px"
                  gap="8px"
                  align="center"
                  p="16px"
                >
                  <Box w="24px" h="24px">
                    <Image
                      src="/assets/android.svg"
                      w="24px"
                      h="24px"
                      objectFit="contain"
                    />
                  </Box>
                  <Text color="#fff" fontSize="15px" lineHeight="21px">
                    Android
                  </Text>
                </Flex>
              </a>

              <a
                href="https://apps.apple.com/us/app/bizflex-africa/id6754340965"
                target="_blank"
                rel="noreferrer"
              >
                <Flex
                  bg="#1A1C1F"
                  borderRadius="8px"
                  gap="8px"
                  align="center"
                  p="16px"
                >
                  <Box w="24px" h="24px">
                    <Image
                      src="/assets/apple.svg"
                      w="24px"
                      h="24px"
                      objectFit="contain"
                    />
                  </Box>
                  <Text color="#fff" fontSize="15px" lineHeight="21px">
                    iOS
                  </Text>
                </Flex>
              </a>
            </Flex>
            <Box mt="12px" textAlign={{ base: "center", md: "left" }}>
              <Image
                src="/assets/Ndrc.svg"
                alt="Ndrc badge"
                w={{ base: "60px", md: "80px" }}
                h="auto"
                objectFit="contain"
                mx={{ base: "auto", md: "0" }}
              />
            </Box>
          </Flex>

          <Box textAlign={{ base: "center", md: "end" }}>
            <Flex
              align="center"
              gap="12px"
              justifyContent={{ base: "center", md: "flex-end" }}
            >
              {socials.map((item, i) => (
                <Flex
                  key={i}
                  bg="#2463EB"
                  rounded="full"
                  w="32px"
                  h="32px"
                  justifyContent="center"
                  align="center"
                >
                  <a href={item?.link} target="_blank" rel="noreferrer">
                    <Image
                      src={item?.img}
                      w="16px"
                      h="16px"
                      objectFit="contain"
                    />
                  </a>
                </Flex>
              ))}
            </Flex>

            <Text
              my="16px"
              color="#fff"
              fontSize={{ base: "12px", md: "14px" }}
              lineHeight={{ base: "18px", md: "21px" }}
            >
              <Text as="span" fontWeight={600}>
                Email:
              </Text>{" "}
              support@bizflex.africa
            </Text>
            <Text
              my="16px"
              color="#fff"
              fontSize={{ base: "12px", md: "14px" }}
              lineHeight={{ base: "18px", md: "21px" }}
            >
              <Text as="span" fontWeight={600}>
                Whatsapp:
              </Text>{" "}
              0706 636 2917
            </Text>
            <Text
              my="16px"
              color="#fff"
              fontSize={{ base: "12px", md: "14px" }}
              lineHeight={{ base: "18px", md: "21px" }}
            >
              <Text as="span" fontWeight={600}>
                Phone:
              </Text>{" "}
              0201 2296 2504, 0706 636 2917
            </Text>

            <Flex
              mt="16px"
              align={{ base: "center", md: "flex-start" }}
              gap="7px"
              fontSize={{ base: "12px", md: "14px" }}
              lineHeight={{ base: "18px", md: "21px" }}
              color="#fff"
              flexDir={{ base: "column", md: "row" }}
              justifyContent={{ base: "flex-start", md: "flex-end" }}
              pb={{ base: "28px", md: "unset" }}
              borderBottom={{ base: "2px solid #fff", md: "none" }}
            >
              <Text fontWeight={600}>Address:</Text>
              <Text w={{ base: "70%", md: "40%" }}>
                4th Floor, Polystar Tower, 128, Remi Olowude Street, Lekki Phase
                1, Lagos
              </Text>
            </Flex>

            <Flex
              mt="16px"
              align={{ base: "center", md: "flex-start" }}
              gap="7px"
              fontSize={{ base: "12px", md: "14px" }}
              lineHeight={{ base: "18px", md: "21px" }}
              color="#fff"
              flexDir={{ base: "column", md: "row" }}
              justifyContent={{ base: "flex-start", md: "flex-end" }}
            >
              <Text w={{ base: "90%", md: "70%" }}>
                BizFlex is a financial technology product offered by FastaMoni
                Technologies Limited. BizFlex is not a bank; all banking
                services are provided by our licensed banking partners.
              </Text>
            </Flex>

            <Flex
              justifyContent={{ base: "center", md: "flex-end" }}
              gap={5}
              flexWrap="wrap"
            >
              {footerSubLinks.map((item, i) => (
                <Link key={i} href={item.id}>
                  <Text
                    mt={{ base: "50px", md: "20px" }}
                    mb="10px"
                    color="#646060"
                    fontSize={{ base: "12px", md: "16px" }}
                    lineHeight={{ base: "19.68px", md: "24px" }}
                  >
                    {item.name}
                  </Text>
                </Link>
              ))}
            </Flex>
            <Text
              color="#646060"
              fontSize={{ base: "10px", md: "16px" }}
              lineHeight={{ base: "15px", md: "24px" }}
            >
              © {today.getFullYear()} Fastamoni. All rights reserved.
            </Text>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Footer;
